import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Table, Button, Sidebar, Icon, Message } from 'semantic-ui-react';
import { exportDataToExcel, uploadExcelData } from '../../../helpers/excel';

import SideEditor from '../../general/SideEditor';
import LoadBudget from '../budgets/LoadBudget';
import WorkerEditor from './WorkerEditor';

import { fetchCompanyBudgetGroups, fetchWorkers, lockBudgetMethod, setEditedEntity, removeWorker, confirmDelete, startBudgetLoad, cancelBudgetLoad, addWorkerToCompany } from '../../../actions';
import { getBudgetCards } from '../../../selectors';
import { formatPrice } from '../../../helpers/format';

import './Workers.scss';

class Workers extends Component {
    uploader = null;

    state = {
        error: ''
    }

    componentWillMount() {
        if (this.props.company.id) {
            this.props.fetchWorkers(this.props.company.id);
            this.props.fetchCompanyBudgetGroups(this.props.company.id);
        }
    }

    navigateToWorker(worker) {
        this.props.history.push(`/company/${this.props.company.id}/workers/${worker.userId}`);
    }

    handleDelete(card) {
        this.props.confirmDelete(card.name, () => this.props.removeWorker(this.props.company.id, card.id));
    }

    handleUploadClick = () => {
        this.setState({ error: '' });
        this.uploader.click();
    }

    handleUploadChange = (e) => {
        const files = e.target.files;
        if (files && files[0]) this.uploadWorkersInfoAsExcel(files[0]);
    }

    addMultipleWorkerFromExcelData = (data) => {
        for (let row = 1; row < data.length; row++) {
            const rowData = data[row];

            if (rowData.length) {
                const phone = rowData[0];
                const budgetGroup = this.props.budgetGroups.find(group => group.name == rowData[1]);

                if (budgetGroup) {
                    this.props.addWorkerToCompany(this.props.company.id, { budgetGroupId: budgetGroup.id, phone });
                } else {
                    this.setState({ error: i18next.t('excel.wrongBudgetGroup') });
                }
            }
        }
    }

    uploadWorkersInfoAsExcel = (file) => {
        uploadExcelData(file, (data) => {
            this.addMultipleWorkerFromExcelData(data);
        });
    }

    exportWorkersExcelTemplate = () => {
        exportDataToExcel('employees_info_upload_template', 'Employees info', [{ "Phone Number": null, "Budget type": null }]);
    };

    render() {
        const styles = {
            negativeAction: {
                backgroundColor: '#d65f5f'
            },
            positiveAction: {},
            currentMonthLoadedLabel: {
                color: 'white',
                backgroundColor: '#1f5884'
            },
            currentMonthUsedLabel: {
                color: 'white',
                backgroundColor: '#6bb3ea'
            }
        };

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('addWorker')}
                    visible={this.props.onEdit}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <WorkerEditor companyId={this.props.company.id} />
                </SideEditor>
                <SideEditor
                    title={i18next.t('loadBudget')}
                    visible={this.props.budgetLoad}
                    handleClose={() => this.props.cancelBudgetLoad()}
                >
                    <LoadBudget company={this.props.company} />
                </SideEditor>
                <div style={{ marginBottom: 10 }}>
                    <Button
                        icon
                        labelPosition='left'
                        primary
                        onClick={() => this.props.setEditedEntity('budgerCard')}
                    >
                        <Icon name='add' /> {i18next.t('addWorker')}
                    </Button>

                    <Button type='button' labelPosition='left' icon='file excel outline'
                        content={i18next.t('excel.load')}
                        onClick={this.handleUploadClick}
                        className='pi-workers-excel-button'
                    />
                    <Button type='button' labelPosition='left' icon='download'
                        content={i18next.t('excel.downloadTemplate')}
                        onClick={this.exportWorkersExcelTemplate}
                        className='pi-workers-excel-button'
                    />

                    <input
                        type='file'
                        accept=".xlsx, .xls"
                        ref={(ref) => this.uploader = ref}
                        onChange={this.handleUploadChange}
                        style={{ display: "none" }}
                    />

                    <Button
                        content={i18next.t('loadBudget')}
                        floated="right"
                        primary
                        onClick={() => this.props.startBudgetLoad(this.props.company.monthlyCycleStartDay)}
                    />

                    {
                        this.state.error ?
                            <Message
                                error
                                icon='upload'
                                onDismiss={() => this.setState({ error: '' })}
                                header={i18next.t('general.error')}
                                content={this.state.error}
                            />
                            :
                            null
                    }

                </div>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine>#</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('phone')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('name')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('cardNumber')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('budget')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('currentPeriod')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('actions')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.budgetCards.map((card, index) => {
                            const { name, dailyLimit, monthlyLimit } = card.budgetGroup || {};

                            return (
                                <Table.Row
                                    key={card.id}
                                    error={!card.loadedAmount}
                                    active={Boolean(card.isDisabled)}
                                >
                                    <Table.Cell collapsing>{index + 1}</Table.Cell>
                                    <Table.Cell>{card.phone}</Table.Cell>
                                    <Table.Cell>{card.name || i18next.t('unregisted')}</Table.Cell>
                                    <Table.Cell>
                                        {card.label}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {`${name} (${dailyLimit}/${monthlyLimit})`}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {!card.loadedAmount ? i18next.t('notLoaded') :
                                            formatPrice(card.loadedAmount, this.props.company.currencyCode)}
                                        {!card.loadedAmount ? '' :
                                            ' / ' + formatPrice(card.usedAmount, this.props.company.currencyCode)}
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Button
                                            circular
                                            size='tiny'
                                            icon='find'
                                            primary
                                            onClick={() => this.navigateToWorker(card)}
                                        />
                                        {card.isDisabled ?
                                            <Button circular size='tiny' icon='unlock' positive style={styles.positiveAction}
                                                onClick={() => this.props.lockBudgetMethod(this.props.company.id, card.id, false)} />
                                            :
                                            <Button circular size='tiny' icon='lock' negative style={styles.negativeAction}
                                                onClick={() => this.props.lockBudgetMethod(this.props.company.id, card.id, true)} />
                                        }
                                        <Button circular size='tiny' icon='trash' negative style={styles.negativeAction} onClick={() => this.handleDelete(card)} />
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

Workers.propTypes = {
    history: PropTypes.object,
    company: PropTypes.object,
    fetchCompanyBudgetGroups: PropTypes.func,
    fetchWorkers: PropTypes.func,
    addWorkerToCompany: PropTypes.func,
    budgetGroups: PropTypes.array,
    budgetLoad: PropTypes.object,
    budgetCards: PropTypes.array,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    lockBudgetMethod: PropTypes.func,
    removeWorker: PropTypes.func,
    confirmDelete: PropTypes.func,
    startBudgetLoad: PropTypes.func,
    cancelBudgetLoad: PropTypes.func,
    
};

const mapStateToProps = (state, ownProps) => {
    const { budgetLoad, budgetGroups } = state.budgetsApp;
    const budgetCards = getBudgetCards(state);
    const onEdit = state.editor.type === 'budgerCard';
    const isRtl = i18next.dir() === 'rtl';

    return { budgetCards, onEdit, budgetLoad, budgetGroups, isRtl };
};

export default connect(mapStateToProps, {
    fetchCompanyBudgetGroups, fetchWorkers, lockBudgetMethod, setEditedEntity, removeWorker, confirmDelete, startBudgetLoad, cancelBudgetLoad, addWorkerToCompany
})(Workers);
